module.exports = __webpack_public_path__ + "static/media/bookchukil2 Translated by J_Lee_77777.03371613.md";